<template>
    <v-form>
        <v-text-field
            v-model="registrationLink.title"
            label="Nama"
        ></v-text-field>

        <v-autocomplete
            v-model="registrationLink.periodId"
            auto-select-first
            :items="periods"
            label="Periode"
        ></v-autocomplete>

        <v-text-field
            @change="checkSlugAvailability"
            v-model="registrationLink.slug"
            label="Link"
            :loading="$store.get('loader/loading', 'slugLookup')"
            :success-messages="slugSuccessMessage"
            :error-messages="slugErrorMessage"
        ></v-text-field>
        <div>
            <v-btn
                @click="generateSlug(4)"
                small
                color="primary"
                text
            >
                <v-icon left>mdi-sync</v-icon>
                pendek
            </v-btn>
            <v-btn
                @click="generateSlug(20)"
                small
                color="primary"
                text
            >
                <v-icon left>mdi-sync</v-icon>
                panjang
            </v-btn>
        </div>
        User akan mendaftar melalui link: {{ baseUrl }}/d/
        <strong>{{ displayedLink }}</strong>

        <!--
        <v-text-field
            v-model="registrationLink.icon"
            label="Nama Icon"
            hint="Icon akan ditampilkan di halaman pendaftaran"
        ></v-text-field>

        <div>
            Icon yang dipilih: <v-icon>mdi-{{ registrationLink.icon }}</v-icon> (akan tampil bila nama benar)
        </div>
        <div>
            Cari icon di <a href="https://materialdesignicons.com/" target="_blank">di sini</a> dan ketikan nama icon pada kolom di atas
        </div>
        -->

        <v-checkbox
            v-model="useSpecialRequirement"
            :disabled="useSpecialPrice"
            label="Kebutuhan khusus"
            hint="Kebutuhan yang perlu dilakukan oleh user setelah mendaftar. Contoh: upload screenshot bukti"
            persistent-hint
        ></v-checkbox>

        <v-textarea
            v-if="useSpecialRequirement"
            v-model="registrationLink.specialRequirement"
            label="Kebutuhan khusus"
        ></v-textarea>

        <v-checkbox
            v-model="useSpecialPrice"
            :disabled="useSpecialRequirement"
            label="Harga khusus"
        ></v-checkbox>

        <v-text-field
            v-if="useSpecialPrice"
            v-model="registrationLink.specialPrice"
            label="Harga khusus"
            prefix="Rp."
        ></v-text-field>

        <v-checkbox
            v-model="useValidUntil"
            label="Dapat kadaluarsa"
        ></v-checkbox>

        <date-time-picker
            v-if="useValidUntil"
            v-model="registrationLink.validUntil"
        ></date-time-picker>
    </v-form>
</template>

<script>
import DateTimePicker from '@/components/DateTimePicker'

const DEFAULT_ICON = 'star'

const registrationLink = () => ({
    title: null,
    periodId: null,
    icon: null,
    slug: null,
    specialPrice: null,
    specialRequirement: null,
    validUntil: null,
})

export default {
    components: {
        DateTimePicker,
    },

    data: () => ({
        periods: null,
        useSpecialPrice: false,
        useSpecialRequirement: false,
        useValidUntil: false,
        baseUrl: process.env.VUE_APP_BASE_URL,
        slugSuccessMessage: '',
        slugErrorMessage: '',
        registrationLink: registrationLink(),
    }),

    computed: {
        displayedLink() {
            return this.registrationLink.slug
                ? this.registrationLink.slug
                : '{link}'
        },
    },

    watch: {
        useSpecialRequirement() {
            if (this.useSpecialRequirement) {
                this.useSpecialPrice = false
            } else {
                this.registrationLink.specialRequirement = null
            }
        },

        useSpecialPrice() {
            if (!this.useSpecialPrice) {
                this.registrationLink.specialPrice = null
            }
        },

        useValidUntil() {
            if (!this.useValidUntil) {
                this.registrationLink.validUntil = null
            }
        },

        registrationLink: {
            handler() {
                this.$emit('input', this.registrationLink)
            },
            deep: true,
        },
    },

    methods: {
        generateSlug(length) {
            const characters =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
            const charactersLength = characters.length
            let result = ''

            for (let i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                )
            }

            this.registrationLink.slug = result
            this.checkSlugAvailability()
        },

        async checkSlugAvailability() {
            this.slugSuccessMessage = ''
            this.slugErrorMessage = ''

            if (!this.registrationLink.slug) {
                return
            }

            const response = await this.$apiv2.get(
                `registration-link/check-slug/${this.registrationLink.slug}`,
                { loader: 'slugLookup' }
            )

            if (response.data.isAvailable) {
                this.slugSuccessMessage = 'Link tersedia'
            } else {
                this.slugErrorMessage = 'Link tidak tersedia, gunakan link lain'
            }
        },

        reset() {
            this.registrationLink = registrationLink()
        },
    },

    async created() {
        this.registrationLink.icon = DEFAULT_ICON

        const response = await this.$api.get('period', {
            loader: 'createRegistrationLink',
        })

        this.periods = response.data.periods.map((period) => ({
            text: period.title,
            value: period.id,
        }))
    },
}
</script>
